export const dynamicsConstants = {
  // Any changes here --> change in Privacy.json
  dynamicsWkwServiceId: 'dynamicsWkwService',
  dynamicsWkwHelpLink: 'https://docs.microsoft.com/en-us/dynamics365/ai/sales/who-knows-whom',
  dynamicsScenarioId: '2a60a40d-8463-4876-86cd-09d698b79aac',
  dynamicsMetadataId: '00000000-0000-0000-0000-000000000000',
  dynamicsODFCSetting: 'OptedOut'
};
